<template>
  <div class="flower">
    <app-header :background-name="'wallpaper_reiki.jpg'">
      <h1>Stéphanie Lefebvre</h1>
      <h2>Précautions sanitaires liées au Covid-19</h2>
    </app-header>

    <div class="content">
      <h4 class="custom">
        « Prendre soin des autres, c’est aussi prendre soin de soi »
      </h4>
      <article>
        <div class="bloc">
          <h1>Côté praticien</h1>
          <p>
            Le praticien porte <span>un masque</span>.
            Le lavage des mains est effectué minutieusement avant l’entrée du client, avant de
            pratiquer le soin, après le soin, et après le départ du client.
          </p>

          <p>
            La pièce est <span>aérée entre chaque séance</span>. Une <span>désinfection</span> de tout le matériel
            (table de
            massage, bureau, chaise, crayons…) et de la pièce (poignées de porte, sol…) est
            effectuée avant et après chaque séance.
            Le drap de protection de la table est bien sûr changé comme d’habitude entre chaque client.
          </p>

        </div>
        <div class="bloc">
          <h1>Côté client</h1>
          <p>
            <span>Le client doit venir muni d’un masque.</span></p>
          <p>
            A son entrée, il se désinfecte obligatoirement les mains. Du gel hydroalcoolique est à sa disposition à cet effet.
          </p>
          <p>
            En cas de symptômes ou de température égale ou supérieure à 38°C avant le rendez-vous, il est demandé au
            client d’en avertir le praticien, afin de reporter la séance d’au
            moins 2 semaines minimum.
          </p>

          <p>
            Avant de sortir, le client se désinfecte à nouveau les mains.
          </p>

          <b>Je vous remercie pour le respect de ces précautions sanitaires.</b>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
  import AppHeader from '@/components/Header'

  export default {
    name: 'Flower',
    components: { AppHeader }
  }
</script>

<style lang="scss" scoped>
  .flower {
    display: flex;
    flex-direction: column;
    flex: 1;

    .content {
      position: relative;
      text-align: center;
      background-color: #f1fae7;
      align-items: center;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      @media screen and (max-width: 680px) {
        overflow: auto;
      }

      h4 {
        width: 50%;
        margin: .5em;
        font-size: 1.1em;
        font-family: 'Delius', cursive;
        border-bottom: 2px solid $color-green;
        padding-bottom: 1em;
        font-weight: 700;
      }

      article {
        @include custom-article();

        img {
          position: absolute;
          z-index: 0;
          opacity: .5;

          &.left {
            bottom: 2vw;
            left: 3vw;
            transform: scaleX(-1);
          }

          &.right {
            top: 0;
            right: 3vw;
            transform: rotate(90deg);
          }
        }
      }
    }
  }
</style>
